import * as QuestionnaireApiModels from '@/typings/questionnaires-api-models';

const getFieldValue = ({ field, value }: { field: Pick<QuestionnaireApiModels.FieldTemplate, 'type'> | null; value: unknown }): unknown => {
  if (!value) {
    return value as string | number | null | undefined;
  }
  if (field && ['number'].includes(field.type)) {
    return Number(value);
  }
  // List fields (list fields always have a _id field)
  if (field && ['list', 'table'].includes(field.type)) {
    return value;
  }

  if (Array.isArray(value)) {
    if (value.length === 1) {
      return value[0]; // multi select field but only one field
    }
    return value; // multi-select with multiple values

  }
  return value;
};

export default getFieldValue;
